import { call, put, takeEvery } from "redux-saga/effects";
import { partnerServicePath } from "constants/defaultValues";
import { request } from "services/requests.services";

function* getFloatPartners() {
  try {
    const response = yield request("GET", `${partnerServicePath}/wallet/partnerList`);
    yield put({
      type: "GET_FLOAT_DATA_SUCCESS",
      data: response.data,
      loading: false,
      message: response.msg
    });
  } catch (error) {
    yield put({
      type: "GET_FLOAT_DATA_FAILED",
      message: "Failed to get data!"
    });
  }
}

function* getFloatDataById(action) {
  try {
    const { partnerId, txnSubType, txnFrom, txnTo, page, size } = action.state;
    const requestData = { partnerId, txnSubType, txnFrom, txnTo, page, size };
    const response = yield request("POST", `${partnerServicePath}/wallet/listTransaction`, requestData);
    yield put({
      type: "GET_FLOAT_DATA_BY_ID_SUCCESS",
      data: response.data,
      loading: false,
      message: response.message
    });
  } catch (error) {
    yield put({
      type: "GET_FLOAT_DATA_BY_ID_FAILED",
      message: "Failed to get data!"
    });
  }
}

function* getCurrentBalance(action) {
  try {
    const response = yield request("GET", `${partnerServicePath}/wallet/currentBalance/${action.state.partnerId}`);
    yield put({
      type: "GET_CURRENT_BALANCE_SUCCESS",
      data: response.data.currentBalance,
      loading: false,
      message: response.msg
    });
  } catch (error) {
    yield put({
      type: "GET_CURRENT_BALANCE_FAILED",
      message: "Failed to get data!"
    });
  }
}
function* addUpdateBalance(action) {
  try {
    const response = yield request("POST", `${partnerServicePath}/wallet/addUpdateBalance`, {
      ...action.state
    });
    yield put({
      type: "ADD_UPDATE_BALANCE_SUCCESS",
      data: response.data.currentBalance,
      loading: false,
      message: response.msg
    });
    yield call(getFloatDataById, { state: action.state });
  } catch (error) {
    yield put({
      type: "ADD_UPDATE_BALANCE_FAILED",
      message: "Failed to add data!"
    });
  }
}
function* getFloatDataByTransactionId(action) {
  try {
    const { partnerId, txnSubType, txnFrom, txnTo, page, size } = action.state;

    const requestData = txnSubType === "All Transactions" ? { partnerId, txnFrom, txnTo, page, size } : { partnerId, txnSubType, txnFrom, txnTo, page, size };

    const response = yield request("POST", `${partnerServicePath}/wallet/listTransaction`, requestData);
    yield put({
      type: "GET_FLOAT_DATA_BY_TRANSACTION_ID_SUCCESS",
      data: response.data,
      loading: false,
      message: response.message
    });
  } catch (error) {
    yield put({
      type: "GET_FLOAT_DATA_BY_TRANSACTION_ID_FAILED",
      message: "Failed to get data!"
    });
  }
}

export default function* floatSaga() {
  yield takeEvery("GET_FLOAT_DATA", getFloatPartners);
  yield takeEvery("GET_FLOAT_DATA_BY_ID", getFloatDataById);
  yield takeEvery("GET_FLOAT_DATA_BY_TRANSACTION_ID", getFloatDataByTransactionId);
  yield takeEvery("GET_CURRENT_BALANCE", getCurrentBalance);
  yield takeEvery("ADD_UPDATE_BALANCE", addUpdateBalance);
}
